<template>
  <section class="student-add-new-class-code mb-4">
    <v-card class="pa-2">
      <form @submit.prevent="submit">
        <v-card-text>
          <h2 class="tab-content-title mb-2">Add a New Wokshop Code</h2>
          <p class="tab-content-description">
            Please insert your new class code to enroll into your new class
          </p>
          <v-row
            class="flex-column flex-nowrap"
            align="center"
            justify="center"
          >
            <class-code
              title="class code"
              v-model="classCode"
              v-validate="'required|min:4'"
              data-vv-name="class_code"
              data-vv-as="class code"
              hint="The class code must be supplied to you by a teacher"
              data-vv-validate-on="change"
              :error-messages="errors.collect('class_code')"
            />
            <v-btn
              type="submit"
              :loading="loading"
              :disabled="loading"
              color="primary"
              class="mt-4"
            >
              enroll to class
            </v-btn>
          </v-row>
        </v-card-text>
      </form>
    </v-card>
  </section>
</template>

<script>
import ClassCode from '@/components/ClassCode'
import ClassInvitation from '@/modules/class/models/ClassInvitation'
import Class from '@/modules/class/models/Class'
import { mapMutations } from 'vuex'

export default {
  name: 'AddNewClassCode',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    ClassCode
  },
  data() {
    return {
      classCode: '',
      loading: false,
      errorMessage: []
    }
  },
  computed: {},
  async mounted() {},
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return // there are errors
      }
      try {
        this.loading = true
        await ClassInvitation.dispatch('acceptInvitation', {
          classCode: this.classCode
        })
        await Class.dispatch('fetchForStudent')
        this.loading = false
        this.$parent.newClass = true
        this.showSnackbar('New class connected')
        this.classCode = ''
        this.$emit('classAccepted')
      } catch (error) {
        this.loading = false
        this.showErrorSnackbar('class code is incorrect.')
      }
    }
  }
}
</script>

<style lang="scss">
.student-add-new-class-code {
  .tab-content-title {
    font-size: 20px;
    font-weight: 500;
    color: var(--v-primary-base);
  }
}
</style>
